import { Link } from 'react-router-dom';

const stats = [
  { value: '1,200+', label: '精选影视', icon: 'ri-film-line' },
  { value: '3', label: '内容分类', icon: 'ri-apps-2-line' },
  { value: '每日', label: '持续更新', icon: 'ri-refresh-line' },
];

export default function SiteIntro() {
  return (
    <section className="px-4 md:px-8 py-12 md:py-16">
      <div className="rounded-lg border border-background-200 bg-background-100 overflow-hidden">
        <div className="grid grid-cols-1 lg:grid-cols-2">
          <div className="p-6 md:p-10">
            <span className="inline-flex items-center gap-2 text-sm font-semibold text-accent-400">
              <i className="ri-moon-clear-line"></i>
              关于午夜视频
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              在午夜，遇见值得一看的影视
            </h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
              午夜视频聚焦电影、电视剧与短视频内容，用精选片单与清晰的分类，帮助你在繁杂的信息中快速找到想看的作品。
              我们相信，好的影视需要被更好地发现。无论是深夜一个人的电影，还是碎片时间的短剧，这里都有属于你的那一刻。
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link
                to="/about"
                className="inline-flex items-center gap-2 h-11 px-6 rounded-md bg-primary-500 text-background-950 text-sm font-semibold whitespace-nowrap cursor-pointer hover:bg-primary-400 transition-colors"
              >
                <i className="ri-information-line"></i>
                了解我们
              </Link>
              <Link
                to="/contact"
                className="inline-flex items-center gap-2 h-11 px-6 rounded-md border border-background-300 text-foreground-900 text-sm font-semibold whitespace-nowrap cursor-pointer hover:bg-background-200 transition-colors"
              >
                <i className="ri-chat-3-line"></i>
                联系我们
              </Link>
            </div>
          </div>
          <div className="grid grid-cols-3 border-t lg:border-t-0 lg:border-l border-background-200">
            {stats.map((s) => (
              <div key={s.label} className="flex flex-col items-center justify-center gap-2 py-10 px-2 text-center">
                <span className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-500/15 text-accent-400">
                  <i className={`${s.icon} text-2xl`}></i>
                </span>
                <span className="font-heading text-xl md:text-2xl font-bold text-foreground-950">{s.value}</span>
                <span className="text-xs md:text-sm text-foreground-600">{s.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}